import React, { FC, SVGProps, memo } from 'react';
import { IconColor } from '../../utils/colorTypes';
import colors from '../../theme/colors';

interface Props extends SVGProps<SVGSVGElement> {
  color?: IconColor;
}

const ArrowLongIcon: FC<Props> = ({ color = 'dark', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={12}
      fill="none"
      {...props}
    >
      <path
        fill={colors.icon[color]}
        d="M20.53 6.53a.75.75 0 0 0 0-1.06L15.757.697a.75.75 0 0 0-1.06 1.06L18.939 6l-4.242 4.243a.75.75 0 0 0 1.06 1.06L20.53 6.53ZM0 6.75h20v-1.5H0v1.5Z"
      />
    </svg>
  );
};

export default memo(ArrowLongIcon);
